<template>
  <md-dialog :md-active.sync="isOpen" class="multi-org-modal">
    <md-dialog-title class="modal-title">
      Select your organizations
    </md-dialog-title>
    <md-dialog-content class="modal-body">
      <md-field class="modal-field">
        <label class="modal-label">Organizations</label>
        <md-select
          v-model="selectedOrgs"
          multiple
          name="orgs"
          class="modal-select"
        >
          <md-option
            v-for="org in organizations"
            :key="org.orgId"
            :value="org.orgId"
          >
            {{ org.orgName }}
          </md-option>
        </md-select>
        <p v-if="showError" class="error-message">Please select at least one organization.</p>
      </md-field>
    </md-dialog-content>
    <md-dialog-actions class="modal-actions">
      <button class="btn cancel" @click="cancel">CANCEL</button>
      <button class="btn confirm" :disabled="selectedOrgs.length === 0" @click="save">SAVE</button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  name: "ChooseOrganizationModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedOrgs: [],
      organizations: [],
      showError: false
    };
  },
  created() {
    this.loadOrganizations();
  },
  methods: {
    loadOrganizations() {
      try {
        const orgsData = sessionStorage.getItem("organizations");
        if (orgsData) {
          this.organizations = JSON.parse(orgsData);
        }
      } catch (error) {
        console.error("Error loading organizations:", error);
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    save() {
      if (!this.selectedOrgs.length) {
        this.showError = true;
        return;
      }
      this.showError = false;
      this.$emit("save", this.selectedOrgs);
    }
  }
};
</script>

<style scoped>
@import "~vue-material/dist/theme/default.css";

.md-dialog.md-theme-default {
  border-radius: 16px;
  padding: 24px;
}

.modal-body{
  padding: 0;
}
.modal-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  padding: 8px 0;
}
.modal-label {
  font-weight: 700;
  color: #000;
  margin-bottom: 12px;
}
.modal-select {
  border-radius: 8px;
  font-size: 14px;
  min-height: 40px;
}
.modal-subtext {
  margin-top: 8px;
  font-size: 12px;
  color: #666;
}
.error-message {
  color: #f44336;
  font-size: 13px;
  margin-top: 6px;
}
.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: end;
  padding: 8px 0;
}
.btn {
  padding: 8px 18px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
  border: none;
}
.btn.cancel {
  background-color: #e0e0e0;
  color: #333;
}
.btn.confirm {
  background-color: #4caf50;
  color: white;
}
.btn.cancel:hover {
  background-color: #d5d5d5;
}
.btn.confirm:hover {
  background-color: #43a047;
}
</style>